import styles from "./AppBar.module.css";
import { LogoutIcon } from "./LogoutIcon.tsx";

export const AppBar: React.FC<{
  isAuthenticated?: boolean;
  onLogoutClick?: () => void;
  unauthenticatedActions?: React.ReactNode;
  appTitle: string;
}> = (props) => {
  return (
    <div className={styles.AppBarContainer}>
      <h1 className={styles.AppTitle}>Ipsos | {props.appTitle}</h1>
      <div className={styles.ButtonsContainer}>
        {props.unauthenticatedActions}
        {props.isAuthenticated && (
          <button onClick={props.onLogoutClick} className={styles.IconButton}>
            <LogoutIcon />
          </button>
        )}
      </div>
    </div>
  );
};
